import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
import { GROW_GUIDE_TIERS } from '../constants';
export const getStyle = ({
  tier
}) => {
  const isFree = tier === GROW_GUIDE_TIERS.FREE;
  const isPro = tier === GROW_GUIDE_TIERS.PRO;
  if (isFree) {
    return {
      blockSize: '200px',
      inlineSize: '400px',
      position: 'absolute',
      insetBlockStart: 'calc(var(--global-nav-height, 86px) + 16px)',
      insetInlineStart: 'calc(100% - 400px - 16px)',
      background: 'white',
      zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT,
      transition: 'all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      border: '1px solid black'
    };
  }
  if (isPro) {
    return {};
  }
  return {};
};